import type Component from "../Component.ts";
import {getSingleParameter} from "../JobObjectHelper.ts";

const ImplementationId = -741198691

export interface DatabaseQueryComponent {
    databaseType: string
    connectionOptionKeys: string[]
}

export function databaseQueryComponent(component: Component): DatabaseQueryComponent | undefined {
    if(component.implementationID !== ImplementationId) return undefined
    const connectionOptionParam = component.parameters["11"]
    const connectionOptionKeys = Object.values(connectionOptionParam.elements).map((element) => element?.values[1]?.value ?? "")
    return {
        databaseType: getSingleParameter(component, 2) ?? "-- Unknown",
        connectionOptionKeys: connectionOptionKeys.filter((key) => key !== "")
    }
}